module.exports = __webpack_public_path__ + "static/media/cross.9619fc04.svg";